import React from 'react';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { NotFound } from 'src/widgets/notFound';
import { useHelmet } from 'src/shared/helmet';
import { useStaticRouterContext } from '../../shared/context/staticRouterContext/context';

const NotFoundPage: React.FC = () => {
  const Helmet = useHelmet();
  const staticRouterContext = useStaticRouterContext();

  if (staticRouterContext) {
    staticRouterContext.statusCode = HttpStatusCode.NotFound;
  }

  return (
    <div>
      <Helmet>
        <title>Страница не найдена</title>
        <meta content="К сожалению, запрашиваемая страница не найдена." name="description" />
      </Helmet>
      <NotFound />
    </div>
  );
};

export default NotFoundPage;
